export default class Header {
  constructor() {
    this.header = document.querySelector("[data-header]");
    this.headerHight = this.header.scrollHeight;
    this.breakpoint = window.matchMedia("(min-width: 1200px)");
    this.burger = document.querySelector("[data-burger]");

    this.isScroll();

    this.burger.addEventListener("click", () => {
      this.header.classList.remove("scroll", "show");
    });
  }

  isScroll = () => {
    if (!this.breakpoint.matches) {
      this.header.classList.remove("scroll", "show");
      return;
    }
    let oldScroll = window.scrollY;

    window.addEventListener("scroll", (e) => {
      if (window.scrollY < this.headerHight && this.breakpoint.matches) {
        this.header.classList.remove("scroll", "show", "transition");
        return;
      }

      const newScroll = window.scrollY;

      if (newScroll > oldScroll) {
        this.header.classList.remove("show");
      } else {
        this.header.classList.add("transition");
        this.header.classList.add("scroll", "show");
      }

      oldScroll = newScroll;
    });
  };
}
